// LocalStorage Keys
export const OC_SIGNUP_RETURN_URL = 'oc-signupReturnUrl'
